import React, { useState, useEffect } from "react";
import { Modal, ModalDialog } from "react-bootstrap";
import { sendData, getData } from "../../../services/auth";
import { InputLabelAlert } from "../../../common/layout";
import { uriList } from "../../../helpers/config";
import { width, SimNao } from "../../../helpers";
import { Button } from "reactstrap";
import * as moment from "moment";
import Draggable from "react-draggable";
let tipos = [
    { id: 'COLABORADORES', nome: 'Colaboradores' },
    { id: 'EMPRESA', nome: 'Empresa' },
    { id: 'AMBOS', nome: 'Ambos' },
]

let categorias = [
    { id: 'DOCUMENTO', nome: 'Documento' },
    { id: 'IMAGEM', nome: 'Imagem' },
    { id: 'QRCODE', nome: 'QRCode' },
    { id: 'OUTROS', nome: 'Outros' },
]

class DraggableModalDialog extends React.Component {
    render() {
        return (
            <Draggable handle=".modal-header">
                <ModalDialog {...this.props} />
            </Draggable>
        );
    }
}


const InclusaoTipos = (props) => {
    const [gravando, setGravando] = useState(false)
    const [data, setData] = useState({ id: 0, nome: "", tipo: "", categoria: "" });
    const [validated, setValidated] = useState(true)
    const [gravou, setGravou] = useState(false)
    const [tiposDoc, setTiposDoc] = useState(props.tipos)
    const [marcarTodos, setMarcarTodos] = useState(false)

    useEffect(() => {
        if (props.data) {
            let _data = {
                id: props.data.ID,
                nome: props.data.NOME,
                tipo: props.data.TIPO,
                categoria: props.data.CATEGORIA,
                limitador: props.data.LIMITADOR
            }

            console.log("InclusaoTipos.useEffect(1): ", _data)
            setData(_data)
        }

    }, []);

    function closeModal() {
        if (props.onCloseEv)
            props.onCloseEv(gravou)
    }

    function validarDados(event) {
        const form = document.getElementById('form-tipos-documento')
        console.log("UploadDocumentos.validarDados(form): ", form)
        setValidated(false)
        const isValid = form.checkValidity()
        if (!isValid) {
            event.preventDefault()
            event.stopPropagation()
        }

        setValidated(true)
        return isValid
    }

    async function handlePost(e,isClosed) {
        if (!validarDados(e))
            return

        console.log("Gravando Tipo de Documento: ", data);
        setGravando(true)
        await sendData({ uri: uriList("tiposDocumentoAdd"), content: { ...data, empresaid: props.empresaid, usuarioid: props.usuarioid } })
            .then((res) => {
                setGravando(false)
                if (res.status && parseInt(res.status) > 200) throw new Error();
                console.log("Tipos de Documento - Gravado: ", res);
                setData({ id: 0, nome: "", tipo: "", categoria: "" });
                setGravou(true)
                if (isClosed)
                    closeModal()
            })
            .catch((e) => {
                setGravando(false)
                console.log(e);
                alert("Erro ao Gravar Tipos de Documento.\n" + e.message);
            });

    }

    function handleChange(e) {
        let target = e.currentTarget;
        let name = target.name;
        let value = target.value?.toUpperCase();

        setData({ ...data, [name]: value });
        // console.log(`handleChange: ${name} = ${value}`);
    }

    const handleBlur = (e, userData) => {
        let target = e.currentTarget;
        let name = target.name;
        let value = userData || target.value;

        setData({ ...data, [name]: value });
    };

    function handleMarcar(_tipo) {
        let _tipos = tipos.map(tipo => {
            if (tipo.id === _tipo.id)
                tipo.selecionado = !tipo.selecionado
            return tipo
        })
        setTiposDoc(_tipos)
    }

    async function handleGravarTiposAux() {

    }

    function handleMarcarTodos() {
        let _tipos = tiposDoc.map(tipo => {
            tipo.selecionado = !marcarTodos
            return tipo
        })
        console.log("InclusaoTipos.handleMarcarTodos(tipos): ", _tipos)
        console.log("InclusaoTipos.handleMarcarTodos(tiposDoc): ", tiposDoc)
        setTiposDoc(_tipos)
        setMarcarTodos(!marcarTodos)
        handleGravarTiposAux()
    }


    function GetTiposDocumentoAux() {
        return (
            <>
                <div style={{ borderTop: "1px solid lightGray" }}></div>
                <h5 className="text-center mt-2">Tipos de Documento a Exibir(QRCODE)</h5>
                <div style={{ height: "30vh", width: "100%", overflowX: "auto", marginLeft: "4px" }}>
                    <table className="table table-striped table-bordered rounded " title={"Clique para acessar o documento"} >
                        <thead >
                            <th scope="col" style={{ width: "5%", textAlign: "center" }}><input type="checkbox" id="cb_baixar_todos" checked={marcarTodos} onClick={handleMarcarTodos}
                            /></th>
                            <th scope="col" style={{ width: "95%" }}>Nome</th>
                        </thead>
                        <tbody style={{ overflow: "auto" }}>
                            {tiposDoc && tiposDoc.filter(tipo => tipo.ID != data.id && (tipo.TIPO == data.tipo || tipo.TIPO == "AMBOS" || data.tipo == "AMBOS")).map((_tipo, index) => {
                                return (
                                    <tr style={{ cursor: "pointer" }} >
                                        <td style={{ width: "5%", textAlign: "center" }}><input type="checkbox" id="cb_baixar" checked={_tipo.selecionado}
                                            onClick={(e) => handleMarcar(_tipo)} /></td>
                                        <td style={{ width: "95%" }}>{_tipo.NOME && _tipo.NOME.slice(0, 70)}</td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
            </>
        )
    }

    return (
        <div>
            <Modal
                size={width() == "mobile" ? "sm" : "lg"}
                show={true}
                onHide={closeModal}
                centered
                animation={false}
                backdrop="static"
                dialogAs={DraggableModalDialog}
            >
                <Modal.Header closeButton >
                    <Modal.Title>
                        <span>Cadastro de Tipos de Documento</span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="maxWidth750">
                    {gravando ? (
                        <div>Gravando registro...</div>
                    ) : (
                        <form className={`form g-2 border p-2 needs-validation ${validated ? ' was-validated ' : ''}`} noValidade
                            id="form-tipos-documento" style={{ overflow: "hidden" }}>
                            <div className="row">
                                <div className="form-group col-md-8">
                                    <InputLabelAlert
                                        type="text"
                                        label="Nome"
                                        id="nome"
                                        cifrao={false}
                                        value={data.nome}
                                        handle={handleChange}
                                        focus={true}
                                        onBlur={handleBlur}
                                        required={true}
                                    />
                                </div>
                                <div className="form-group col-md-4">
                                    <label className="m-0 font-90">Categoria</label>
                                    <select
                                        className="form-control"
                                        defaultValue={data.categoria}
                                        onChange={(e) =>
                                            setData({ ...data, ["categoria"]: e.target.value })
                                        }
                                        required
                                    >
                                        <option value="" selected={!data.categoria}>Escolha uma categoria...</option>
                                        {categorias &&
                                            categorias.map((item, key) => {
                                                if (!data.categoria) {
                                                    setData({ ...data, ["categoria"]: item.id });
                                                }
                                                return (
                                                    <option key={key} value={item.id} selected={item.id == data.categoria}>
                                                        {item.nome}
                                                    </option>
                                                );
                                            })}
                                    </select>
                                    {/* <InputLabelAlert
                                        type="text"
                                        label="Categoria"
                                        id="categoria"
                                        cifrao={false}
                                        value={data.categoria}
                                        handle={handleChange}
                                        focus={false}
                                        onBlur={handleBlur}
                                    /> */}
                                </div>

                            </div>
                            <div className="row">
                                <div className="form-group col-md-4">
                                    <label className="m-0 font-90">Tipo</label>
                                    <select
                                        className="form-control"
                                        defaultValue={data.tipo}
                                        onChange={(e) =>
                                            setData({ ...data, ["tipo"]: e.target.value })
                                        }
                                        required
                                    >
                                        <option value="" selected={!data.tipo}>Escolha um tipo...</option>
                                        {tipos &&
                                            tipos.map((item, key) => {
                                                if (!data.tipo) {
                                                    setData({ ...data, ["tipo"]: item.id });
                                                }
                                                return (
                                                    <option key={key} value={item.id} selected={item.id == data.tipo}>
                                                        {item.nome}
                                                    </option>
                                                );
                                            })}
                                    </select>
                                </div>
                                <div className="form-group col-md-4">
                                    <label className="m-0 font-90">Limita Integração</label>
                                    <select
                                        className="form-control"
                                        defaultValue={data.limitador}
                                        onChange={(e) =>
                                            setData({ ...data, ["limitador"]: e.target.value })
                                        }
                                        required
                                    >
                                        <option value="" selected={!data.limitador}>Escolha um limitador...</option>
                                        {SimNao.map((item, key) => {
                                            if (!data.limitador) {
                                                setData({ ...data, ["limitador"]: item.value });
                                            }
                                            return (
                                                <option key={key} value={item.value} selected={item.value == data.limitador}>
                                                    {item.label}
                                                </option>
                                            );
                                        })}
                                    </select>
                                </div>
                            </div>
                            {data.categoria == "QRCODE" &&
                                <div className="row">
                                    <GetTiposDocumentoAux />
                                </div>
                            }
                        </form>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button color="success" onClick={e => {handlePost(e,false)}}>
                        Gravar
                    </Button>
                    <Button color="success" onClick={e => {handlePost(e,true)}} >
                            Gravar e Fechar
                    </Button>
                    <Button color="secondary" onClick={closeModal}>
                        Fechar
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default InclusaoTipos;